export default __webpack_public_path__ + "static/media/bg-pattern-intro-right-mobile.0354e571.svg";